var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LoopsHeader'),_c('HorizontalMenu'),_c('router-view'),_c('LoopsStatusBar'),_c('ErrorMessage'),_c('cookie-law')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }